
export const parseAiRecommendationPercentageScore = (score) => {
  return parseInt(score);
}

// only during the yearly window January 1 → December 30
export const isSubmissionWindowOpen = () => {
  const now = new Date();
  const currentYear = now.getFullYear();
  const startDate = new Date(currentYear, 0, 1); // Jan 1 (month 0 = January)
  const endDate = new Date(currentYear, 11, 30);   // Dec 30 (month 11 = December)

  return now >= startDate && now <= endDate;
};

export const canEditSubmission = () => {
  return isSubmissionWindowOpen(); // Same window for editing
};
